import { render, staticRenderFns } from "./homeWorkPage.vue?vue&type=template&id=1aed0419&scoped=true&"
import script from "./homeWorkPage.vue?vue&type=script&lang=js&"
export * from "./homeWorkPage.vue?vue&type=script&lang=js&"
import style0 from "./homeWorkPage.vue?vue&type=style&index=0&id=1aed0419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed0419",
  null
  
)

export default component.exports